import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import styled from 'styled-components';
import { Paragraph } from '../typography/Paragraph.js';
var MessageText = styled(Paragraph)(function (_a) {
  var isVisible = _a.isVisible;
  return css({
    maxHeight: isVisible ? "96px" : "0",
    overflow: "hidden",
    width: "100%",
    marginTop: isVisible ? "8px" : "0",
    transition: "all 200ms",
    color: "red.300"
  });
});
MessageText.defaultProps = {
  size: "sm"
};
var ErrorMessage = function ErrorMessage(_a) {
  var children = _a.children,
    isVisible = _a.isVisible,
    rest = __rest(_a, ["children", "isVisible"]);
  return React__default.createElement(MessageText, __assign({
    isVisible: isVisible
  }, rest), children);
};
export { ErrorMessage };